import type { Routes } from "@angular/router";

/**
 * Routes for the design preview. Empty in every shipped build: the local
 * development configuration swaps this file for preview.routes.local.ts
 * (angular.json fileReplacements), so the preview and its demo data cannot
 * reach a deployed site.
 */
export const PREVIEW_ROUTES: Routes = [];
